import {
  IBasicInfoDistributor,
  IBasicInfoLargeFormat,
  IBasicInfoReseller,
  IBasicInfoRetail,
  TBasicInfoCreated,
  TBasicInfoDefault,
  TPartnerBasicInfo,
} from '../models/partnerBasicInfo'

export const isBasicInfoCreated = (v: TPartnerBasicInfo): v is TBasicInfoCreated => {
  return v.programType !== null
}

export const isBasicInfoDefault = (v: TPartnerBasicInfo): v is TBasicInfoDefault => {
  return v.programType === null
}

export const isBasicInfoDistributor = (
  v: TPartnerBasicInfo,
  cond: boolean
): v is IBasicInfoDistributor => {
  return cond
}

export const isBasicInfoLargeFormat = (
  v: TPartnerBasicInfo,
  cond: boolean
): v is IBasicInfoLargeFormat => {
  return cond
}

export const isBasicInfoRetail = (v: TPartnerBasicInfo, cond: boolean): v is IBasicInfoRetail => {
  return cond
}

export const isBasicInfoReseller = (
  v: TPartnerBasicInfo,
  cond: boolean
): v is IBasicInfoReseller => {
  return cond
}
